import { useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetLookUpDropdownListQuery } from '../../api';
import { useLanguage } from '../../contexts/LanguageContext';

const TechnicalActionManagerDropdown = ({
  value,
  onChange,
  placeholder,
  disabled = false,
  className = '',
  showClear = true,
  autoSelectFirst = false
}) => {
  const { getCurrentLanguageId } = useLanguage();
  const languageId = getCurrentLanguageId();

  const { data: options = [], isLoading } = useGetLookUpDropdownListQuery({
    LanguageId: languageId,
    GroupCode: 'TECHNICAL_ACTION_MANAGER'
  });

  const dropdownOptions = options.map(item => ({
    label: item.translatedText || item.text,
    value: String(item.code || item.lookupCode)
  }));

  // İlk kayıt otomatik seçilsin
  useEffect(() => {
    if (autoSelectFirst && dropdownOptions.length > 0 && (value === null || value === undefined)) {
      const firstValue = parseInt(dropdownOptions[0].value);
      onChange(firstValue);
    }
  }, [autoSelectFirst, dropdownOptions, value, onChange]);

  // Convert value to string for comparison
  const selectedValue = value !== null && value !== undefined ? String(value) : null;

  return (
    <Dropdown
      value={selectedValue}
      options={dropdownOptions}
      onChange={(e) => onChange(e.value ? parseInt(e.value) : null)}
      placeholder={placeholder}
      disabled={disabled}
      className={className}
      showClear={showClear}
      loading={isLoading}
    />
  );
};

export default TechnicalActionManagerDropdown;
